export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_complete_1.8fe0184b.jpg";